// Hero.js
import React from "react";
import { useNavigate } from "react-router-dom";
import "./Hero.css";

const Hero = () => {
  const navigate = useNavigate();

  const handleExploreClick = () => {
    navigate("/products");
  };

  return (
    <div className="hero-section">
      <video
        className="background-video"
        src="/assets/videos/bg-lighting.mp4"
        autoPlay
        loop
        muted
        playsInline
      />
      <div className="hero-overlay" />
      <div className="hero-text">
        <h1>
          Lighting <span className="glow">That Defines</span> Architecture
        </h1>
        <p className="subtext">Minimal. Powerful. Sustainable.</p>
        <button className="hero-button" onClick={handleExploreClick}>
          Explore Collection
        </button>
      </div>
    </div>
  );
};

export default Hero;
